export default {
    id: '1',
    clienteId:' 123sdfae5a1sdadaf',
    bucketURL:"https://amazon bucket s3"
}


/* isto deveria vir do backend post login*/